import { TemplateId } from '@cibli/shared';

import type { RegisteredTemplate } from '../types';

import ModerneDisplay from './Display';
import ModerneEditPannel from './EditPannel';
import { moderneDefaultParams, moderneParamsSchema } from './schema';

const moderneTemplate: RegisteredTemplate<typeof moderneDefaultParams> = {
  meta: {
    id: 'september' as TemplateId,
    name: 'Moderne',
  },
  schema: moderneParamsSchema,
  defaults: moderneDefaultParams,
  Display: ModerneDisplay as unknown as RegisteredTemplate<typeof moderneDefaultParams>['Display'],
  EditPannel: ModerneEditPannel as unknown as RegisteredTemplate<
    typeof moderneDefaultParams
  >['EditPannel'],
  pdfOptions: {
    printBackground: true,
  },
};

export default moderneTemplate;
